export class LogDownloadReportRequest {
    listReportName: string[] = [];
    idEpisode: number;
    idModule: number;
}